import { z } from 'zod';

import { labelSearchField } from '@/features/labels';

/**
 * Search parameters for the workspace Overview route.
 *
 * Deliberately the same names and the same encoding the board uses — a
 * narrowing means one thing in this workspace, whichever page you read it on
 * ([D3](../../../specs/067-task-labels/research.md#d3)). Absent means
 * everything, so it carries no default: the address says "unfiltered" by
 * carrying nothing rather than by carrying a word for it.
 *
 * Search parameters are user-editable text, so an unrecognised value falls back
 * rather than failing the route. A label identifier naming a label that no
 * longer exists survives parsing on purpose — the page then honestly shows
 * nothing, which is the true answer, where a not-found would claim the address
 * itself was wrong.
 *
 * Lives here rather than in the route module for two reasons: the route holds
 * no rules, and `react-refresh/only-export-components` allows a route file to
 * export nothing but `Route` and components.
 */
export const overviewSearchSchema = z.object({
  labels: labelSearchField,
  // The same `q` the board and the task list carry, read the same way. Two
  // parameters, now, and the comment above still holds for both.
  q: z.string().optional().catch(undefined),
});

export type OverviewSearch = z.infer<typeof overviewSearchSchema>;
